/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { Button, Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { createCloudAccount } from "../graphql/mutations";
const client = generateClient();
export default function CloudAccountCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    account: "",
    refreshToken: "",
  };
  const [account, setAccount] = React.useState(initialValues.account);
  const [refreshToken, setRefreshToken] = React.useState(
    initialValues.refreshToken
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setAccount(initialValues.account);
    setRefreshToken(initialValues.refreshToken);
    setErrors({});
  };
  const validations = {
    account: [],
    refreshToken: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          account,
          refreshToken,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: createCloudAccount.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "CloudAccountCreateForm")}
      {...rest}
    >
      <TextField
        label="Account"
        isRequired={false}
        isReadOnly={false}
        value={account}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              account: value,
              refreshToken,
            };
            const result = onChange(modelFields);
            value = result?.account ?? value;
          }
          if (errors.account?.hasError) {
            runValidationTasks("account", value);
          }
          setAccount(value);
        }}
        onBlur={() => runValidationTasks("account", account)}
        errorMessage={errors.account?.errorMessage}
        hasError={errors.account?.hasError}
        {...getOverrideProps(overrides, "account")}
      ></TextField>
      <TextField
        label="Refresh token"
        isRequired={false}
        isReadOnly={false}
        value={refreshToken}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              account,
              refreshToken: value,
            };
            const result = onChange(modelFields);
            value = result?.refreshToken ?? value;
          }
          if (errors.refreshToken?.hasError) {
            runValidationTasks("refreshToken", value);
          }
          setRefreshToken(value);
        }}
        onBlur={() => runValidationTasks("refreshToken", refreshToken)}
        errorMessage={errors.refreshToken?.errorMessage}
        hasError={errors.refreshToken?.hasError}
        {...getOverrideProps(overrides, "refreshToken")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
